import React from 'react'

const CustomerBalance = (props) => {
   const parentData = props;
  return (
    <div className="card card-borderless p-1">
      {parentData.custBalance.length ? <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{ width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#EAF2E3" }}>
                  <th style={{fontWeight:"bold"}}>Customer Name</th>
                  <th style={{fontWeight:"bold"}} className="text-end">Total Amount</th>
                  <th style={{fontWeight:"bold"}} className="text-end">Paid Amount </th>
                  <th style={{fontWeight:"bold"}} className="text-end">Balance Amount</th>
                </tr>
              </thead>
              <tbody>
                {parentData.custBalance.map((item, index) => (
                  <tr key={index}>
                    <td>{item.customerName}</td>
                    <td className="text-end">
                      {parentData.currency + " " + item.totalAmount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {parentData.currency + " " + item.paidAmount.toFixed(2)}
                    </td>
                    <td className="text-end border-0">
                      {parentData.currency + " " + item.balancePayment.toFixed(2)}
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table> :
            <div>
            <div className="card card-borderless p-1 justify-content-center align-items-center text-center" style={{height:"400px"}}>
              No data
            </div>
          </div> }
            

            
          </div>
  )
}

export default CustomerBalance